<ion-app >

  <p *ngIf="showUatBuildBanner" class="uat-build-banner" role="status">
    {{ 'app-component.uat-build-banner' | translate }}
  </p>

  <div class="responsive-app-container" [ngClass]="{'full-width': allowFullScreen}" >
    <div class="page-container " *ngIf="isReady && appDisabled">
      <div class="layout-page-container">
        <ion-row class="layout-title-spacer">
          <ion-col>
            <div class="layout-title-spacer"></div>
          </ion-col>
        </ion-row>
        <ion-row class="layout-title-spacer">
          <ion-col class="layout-page-logo ">
            <ion-img src="assets/v2/images/vivascore-v.svg"></ion-img>
          </ion-col>
        </ion-row>
        <ion-row class="layout-title-spacer">
          <ion-col>
            <h1>{{'home-page.update.udpate-required' | translate}}</h1>
            <p>{{'home-page.update.update-message' | translate}}</p>
            <ion-button (click)="updateApp()">{{'home-page.update.update-button' | translate}}</ion-button>
          </ion-col>
        </ion-row>
      </div>
    </div>

    <div class="update-nudges-overlay" *ngIf="(isReady && updateAvailable) || !isOnline">
      <div class="update-nudge" *ngIf="isReady && updateAvailable" (click)="updateApp()">
        <span>{{'home-page.update.update-app-minor' | translate}}</span>
      </div>
      <div class="update-nudge" *ngIf="!isOnline">
        <span>{{'home-page.notification.network-offline' | translate}}</span>
      </div>
    </div>


    <!-- app.component.html -->

    <a
      *ngIf="isReady && !appDisabled"
      class="sr-only skip-link"
      href="#main-content"
      (click)="skipToMainContent($event)"
    >{{ 'app-component.aria.skip-to-main' | translate }}</a>

    <div class="app-shell" *ngIf="isReady && !appDisabled">
      <div class="layout-busy-spinner" *ngIf="busyLoading">
        <viva-spinner color="var(--viva-icon-color)"></viva-spinner>
      </div>

      <div class="ai-chat-icon" *ngIf="isReady && chatRouteAllowed && chatAllowed && !vivaBotHiddenByCustomiseMode">
        <viva-chat color="white" [messageText]="miniChatText" [showMoreInfoButton]="showMoreInfoButton" (onMoreInfoClick)="gotoFullChat()"
          (onBotClicked)="aiChatClicked()" (onCloseBubble)="closeMiniChat()" [interactive]="true"></viva-chat>
      </div>

      <ng-container *ngComponentOutlet="mainMenuComponent" />
      <ion-router-outlet id="main-content" class="background-blur-target" ></ion-router-outlet>


    </div>
  </div>
</ion-app>